import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix
import { devConfig } from '../../../config/config'; // Importing development configuration

/**
 * Class representing the FilterPagoPremioView.
 * @extends JetView
 */
export default class FilterPagoPremioView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for ticket number
                            name: 'NoTicket',
                            id: 'NoTicket',
                            type: 'number',
                            label: "<span class='icon-ticket'></span>" + _('No. Ticket'),
                            labelPosition: 'top',
                            placeholder: _('No. Ticket'),
                            required: true, // Field is required
                            invalidMessage: _('Campo Requerido'), // Error message for required field
                        },
                        {
                            view: 'text', // Password input for ticket key
                            name: 'ClaveTicket',
                            id: 'ClaveTicket',
                            type: 'password',
                            label: "<span class='icon-ticket1'></span>" + _('Clave Ticket'),
                            labelPosition: 'top',
                            placeholder: _('Clave Ticket'),
                            required: true, // Field is required
                            invalidMessage: _('Campo Requerido'), // Error message for required field
                            attributes: {
                                autocomplete: 'new-password', // Prevents browser from suggesting passwords
                            },
                        },
                        { id: 'grav5', gravity: 1 }, // Gravity element for layout
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container', // CSS class for styling
            height: screen == 'small' ? 130 : 0, // Conditional height based on screen size
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing input fields
                },
            ],
        };
        const datos = {
            // Sample data object
            ValorPagar: '1.2426',
            ValorApostado: '1.00',
            PremioProyectado: '1.24',
            Estado: 'Ganador',
            Ganador: 'Si',
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav4', gravity: 4 }, // Gravity element for layout
                        {
                            view: 'button', // Button to clear the form
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clears the form
                                $$('formPagoPremio').hide(); // Hides the payment form
                                $$('toolbar').hide(); // Hides the toolbar
                                $$('tablePagoPremio').hide(); // Hides the payment table
                            },
                        },
                        {
                            view: 'button', // Button to consult payment
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            hotkey: 'enter', // Hotkey for the button
                            click: () => {
                                if (this.getRoot().validate()) {
                                    // Validates the form
                                    const filterdata = this.getRoot().getValues(); // Gets form values
                                    this.app.callEvent('pagoPremio:filter', [
                                        filterdata, // Calls event with filter data
                                    ]);
                                    const vthis = this; // Reference to the current context
                                    webix
                                        .ajax() // AJAX request to fetch payment data
                                        .get(
                                            devConfig.geturlApi() + '/UserManagement/GetPagoPremio',
                                            'NoTicket=' +
                                                filterdata.NoTicket +
                                                '&ClaveTicket=' +
                                                filterdata.ClaveTicket,
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Error message on failure
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    text = JSON.parse(text); // Parses the response
                                                    if (text.HasError) {
                                                        // Checks for errors in response
                                                        webix.message({
                                                            title: '¡Error!',
                                                            type: 'alert-error',
                                                            text: _(
                                                                'Ticket no encontrado', // Error message for ticket not found
                                                            ),
                                                        });
                                                    } else {
                                                        vthis.app.callEvent(
                                                            'pagoPremio:data',
                                                            [text.data], // Calls event with payment data
                                                        );
                                                        $$('FilterPagoPremio').hide(); // Hides the filter view
                                                        $$('formPagoPremio').show(); // Shows the payment form
                                                        $$('tablePagoPremio').show(); // Shows the payment table
                                                        $$('toolbar').show(); // Shows the toolbar
                                                        $$('pagerA').show(); // Shows the pager
                                                        $$('back-button').show(); // Shows the back button
                                                        if (
                                                            text.data.Ganador == 'SI' // Checks if the ticket is a winner
                                                        ) {
                                                            $$('templatemMessage').setHTML(
                                                                '<div class="tck-ganador" style="text-align: center;">' +
                                                                    _(
                                                                        'Ticket Ganador', // Displays winner message
                                                                    ) +
                                                                    '</div>',
                                                            );
                                                        } else {
                                                            $$('templatemMessage').setHTML(
                                                                '<div class="tck-perdedor" style="text-align: center;">' +
                                                                    _(
                                                                        'Ticket Perdedor', // Displays loser message
                                                                    ) +
                                                                    '</div>',
                                                            );
                                                        }
                                                        if (
                                                            text.data.Estado == 'A' // Checks if the ticket status is pending
                                                        ) {
                                                            $$('templatemMessage').setHTML(
                                                                '<div class="tck-default" style="text-align: center;">' +
                                                                    _(
                                                                        'Ticket Pendiente', // Displays pending message
                                                                    ) +
                                                                    '</div>',
                                                            );
                                                        }
                                                        if (
                                                            text.data.Estado == 'A' // Updates status for pending tickets
                                                        ) {
                                                            $$('EstadoT').setValue('Pendiente');
                                                        } else if (
                                                            text.data.Estado == 'I' // Updates status for closed tickets
                                                        ) {
                                                            $$('EstadoT').setValue('Cerrado');
                                                        }
                                                        $$('ButtonPagarPremio').hide(); // Hides the payment button
                                                        if (
                                                            text.data.PremioPagado == 'S' // Checks if the prize has been paid
                                                        ) {
                                                            $$('templatemMessage').setHTML(
                                                                '<div class="tck-default" style="text-align: center;">' +
                                                                    _(
                                                                        'Premio Pagado', // Displays prize paid message
                                                                    ) +
                                                                    '</div>',
                                                            );
                                                        } else {
                                                            if (
                                                                text.data.Ganador == 'SI' // Shows payment button for winners
                                                            ) {
                                                                $$('ButtonPagarPremio').show();
                                                            }
                                                        }
                                                    }
                                                },
                                            },
                                        );
                                }
                            },
                        },
                    ],
                },
            ],
        };
        return {
            view: 'form', // Main form view
            id: 'FilterPagoPremio',
            rows: [upper_section, buttons], // Combines upper section and buttons
            elementsConfig: {
                on: {
                    onChange: function (newv, oldv) {
                        // Event handler for input changes
                        this.validate(); // Validates the form on change
                        $$('NoTicket').define('inputHeight', 38); // Sets input height for ticket number
                        $$('NoTicket').refresh(); // Refreshes the input
                        $$('ClaveTicket').define('inputHeight', 38); // Sets input height for ticket key
                        $$('ClaveTicket').refresh(); // Refreshes the input
                    },
                },
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object passed to the init method.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                // Checks screen width for responsive design
                $$('grav4').hide(); // Hides element for small screens
                $$('grav5').hide(); // Hides element for small screens
            }
        });
    }
}

// FILE DOCUMENTED
